// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__3Pz0r","disabled":"button_disabled__1iQlO","hide":"button_hide__2CW1j","text":"button_text__2P6Lh","arrow":"button_arrow__tMNHs"};